// --- Zoom Modal Functions ---
window.openZoomView = function(zoomButton) {
  const mediaWrapper = zoomButton.closest('.media_wrapper');
  const mediaEl = mediaWrapper.querySelector('.media_el').cloneNode(true);
  const zoomInner = document.querySelector('.media_zoom_inner');
  const zoomCloseBtn = zoomInner.querySelector('.zoom_close_btn');
  $('body').addClass('zoom_modal_open');
  zoomInner.innerHTML = '';
  if (zoomCloseBtn) zoomInner.appendChild(zoomCloseBtn);
  zoomInner.appendChild(mediaEl);
  // Gallery videos have no autoplay attribute (they're played per active slide), so the clone
  // has to be started by hand.
  if (mediaEl.tagName === 'VIDEO') {
    mediaEl.muted = true;
    const playing = mediaEl.play();
    if (playing && playing.catch) playing.catch(() => {});
  }
  const zoomContainer = document.querySelector('.media_zoom_container');
  zoomContainer.classList.remove('always_hidden');
  setTimeout(() => {
    zoomContainer.classList.remove('zoom_hidden');
  }, 100);
};

window.closeZoomModal = function() {
   $('body').removeClass('zoom_modal_open');
  const zoomContainer = document.querySelector('.media_zoom_container');
  zoomContainer.classList.add('zoom_hidden');
  zoomContainer.classList.add('always_hidden');
};

// --- Lazy Thumb Loader ---
(function() {
  var loadedThumbs = false;
  function loadLazyThumbs() {
    if (loadedThumbs) return;
    loadedThumbs = true;
    document.querySelectorAll('.lazy-thumb-placeholder').forEach(function(placeholder) {
      var imgSrc = placeholder.getAttribute('data-img-src');
      var alt = placeholder.getAttribute('data-alt');
      var img = document.createElement('img');
      img.src = imgSrc;
      img.alt = alt;
      img.className = 'product_swiper_thumb_item_img';
      img.width = 100;
      img.height = 100;
      var thumbItem = placeholder.querySelector('.product_swiper_thumb_item');
      if (thumbItem) {
        thumbItem.innerHTML = '';
        thumbItem.appendChild(img);
      }
      placeholder.classList.remove('lazy-thumb-placeholder');
    });
  }
  var events = ['click', 'touchstart', 'keyup', 'keydown'];
  events.forEach(function(event) {
    window.addEventListener(event, loadLazyThumbs, { once: true, passive: true });
  });
})();

// --- Lazy Media Loader ---
(function() {
  var loadedMedia = false;
  function loadLazyMedia() {
    if (loadedMedia) return;
    loadedMedia = true;
    document.querySelectorAll('.lazy-media-placeholder').forEach(function(placeholder) {
      var type = placeholder.getAttribute('data-type');
      var mediaWrapper = placeholder.querySelector('.media_wrapper');
      if (type === 'image') {
        var imgSrc = placeholder.getAttribute('data-img-src');
        var alt = placeholder.getAttribute('data-alt');
        var img = document.createElement('img');
        img.src = imgSrc;
        img.alt = alt;
        img.className = 'media_el';
        img.width = 800;
        img.height = 800;
        mediaWrapper.innerHTML = '';
        mediaWrapper.appendChild(img);
      } else if (type === 'video') {
        var videoSrc = placeholder.getAttribute('data-video-src');
        var previewImg = placeholder.getAttribute('data-preview-img');
        var alt = placeholder.getAttribute('data-alt');
        var mediaLabel = alt || 'Country Charms Set';
      
        var video = document.createElement('video');
        video.setAttribute('playsinline', 'true');
        video.setAttribute('loop', 'loop');
        video.setAttribute('autoplay', 'autoplay');
        video.setAttribute('muted', 'muted');
        video.setAttribute('class', 'media_el');
        video.setAttribute('preload', 'metadata');
        video.setAttribute('aria-label', mediaLabel);
        video.setAttribute('poster', previewImg);
        video.width = 800;
        video.height = 800;
      
        var source = document.createElement('source');
        source.src = videoSrc;
        source.type = 'video/mp4';
        video.appendChild(source);
      
        // Fallback image for browsers that don't support video
        var fallbackImg = document.createElement('img');
        fallbackImg.src = previewImg;
        fallbackImg.alt = mediaLabel;
        video.appendChild(fallbackImg);
      
        mediaWrapper.innerHTML = '';
        mediaWrapper.appendChild(video);
      
        // Play the video after appending
        video.play();
      }
      placeholder.classList.remove('lazy-media-placeholder');
    });
  }
  var events = ['click', 'touchstart', 'keyup', 'keydown'];
  events.forEach(function(event) {
    window.addEventListener(event, loadLazyMedia, { once: true, passive: true });
  });
})();

// --- Placeholder Text Adjuster ---
document.addEventListener('DOMContentLoaded', function() {
  function adjustPlaceholderText() {
    const personalizeInputs = document.querySelectorAll('.personalize_input');
    const isMobile = window.innerWidth <= 575;
    var common = window.translations.bundle_builder.common;
    var shortPlaceholder = common.enter_char_placeholder_short;
    var longPlaceholder = common.enter_char_placeholder;
    personalizeInputs.forEach(function(input) {
      input.setAttribute('placeholder', isMobile ? shortPlaceholder : longPlaceholder);
    });
  }
  adjustPlaceholderText();
  window.addEventListener('resize', adjustPlaceholderText);
});

// --- Swiper Init Helper ---
function getSwiperActiveIndex(swiper) {
  if (!swiper) return 0;
  if (typeof swiper.realIndex === 'number' && swiper.realIndex >= 0) {
    return swiper.realIndex;
  }
  if (typeof swiper.activeIndex === 'number' && swiper.activeIndex >= 0) {
    return swiper.activeIndex;
  }
  return 0;
}

function syncBannerLeftBadgeVisibility(swiper, selectors) {
  var section = selectors && selectors.section ? selectors.section : '';
  var bannerLeft = document.querySelector(section + ' .banner_left');
  if (!bannerLeft) {
    bannerLeft = document.querySelector('.product-countrycharm .banner_left');
  }
  if (!bannerLeft || !swiper || !swiper.initialized) return;

  bannerLeft.classList.add('swiper-ready');

  var activeIndex = getSwiperActiveIndex(swiper);
  var activeSlide = swiper.slides ? swiper.slides[swiper.activeIndex] : null;
  var firstSlide = swiper.slides ? swiper.slides[0] : null;
  var isCharmSlideActive = !!(activeSlide && activeSlide.classList.contains('slide_charm_img'));
  var isCharmPreviewOnFirstSlide = activeIndex === 0 && !!(firstSlide && firstSlide.classList.contains('slide_charm_img'));
  // Slide 0: hide. Other slides: show. Exception: slide 0 with charm preview → show.
  var showBadge = activeIndex !== 0 || isCharmSlideActive || isCharmPreviewOnFirstSlide;

  bannerLeft.classList.toggle('is-first-slide', activeIndex === 0);
  bannerLeft.classList.toggle('show-image-badge', showBadge);
}

window.updateBannerLeftBadge = function() {
  if (window.productMainSwiper && window.countryCharmsSetSelectors) {
    syncBannerLeftBadgeVisibility(window.productMainSwiper, window.countryCharmsSetSelectors);
    return;
  }

  var bannerLeft = document.querySelector('.product-countrycharm .banner_left');
  if (bannerLeft && bannerLeft.querySelector('.slide_charm_img')) {
    bannerLeft.classList.add('show-image-badge');
  }
};

// --- Gallery video playback ---
// Gallery <video>s render without autoplay and with preload="none" (see the main gallery in
// sections/main-product-country-charms-set-v2.liquid), so nothing but the poster downloads with
// the page. Only the active slide's video plays - the first play() is what fetches it - and only
// while the gallery is on screen. Everything else stays paused.
function syncGalleryVideos(swiper) {
  if (!swiper || !swiper.slides) return;
  var galleryVisible = swiper.el.dataset.galleryVisible !== 'false';
  Array.prototype.forEach.call(swiper.slides, function(slide, index) {
    var video = slide.querySelector('video.media_el');
    if (!video) return;
    if (galleryVisible && index === swiper.activeIndex) {
      video.muted = true;
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function() {});
    } else if (!video.paused) {
      video.pause();
    }
  });
}

function watchGalleryVisibility(swiper) {
  if (!swiper || !swiper.el || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function(entries) {
    swiper.el.dataset.galleryVisible = entries[0].isIntersecting ? 'true' : 'false';
    syncGalleryVideos(swiper);
  }).observe(swiper.el);
}

window.initCountryCharmsSwipers = function(selectors) {
  if (!window.Swiper || !selectors) return;
  window.productSwiperThumb = new Swiper(selectors.section + ' .product_swiper_thumb', {
    spaceBetween: 2,
    slidesPerView: 6,
    loop: true,
  });
  window.productMainSwiper = new Swiper(selectors.section + ' .product_media_swiper', {
    spaceBetween: 10,
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: selectors.section + ' .banner_left_product_slider .product_slide_next',
      prevEl: selectors.section + ' .banner_left_product_slider .product_slide_prev',
    },
    pagination: {
      el: selectors.section + ' .banner_left_product_slider .product_swiper_pagination',
      type: 'fraction',
    },
    thumbs: {
      swiper: window.productSwiperThumb,
    },
    on: {
      init: function() {
        var self = this;
        syncBannerLeftBadgeVisibility(self, selectors);
        requestAnimationFrame(function() {
          syncBannerLeftBadgeVisibility(self, selectors);
        });
        syncGalleryVideos(self);
        watchGalleryVisibility(self);
      },
      slideChange: function() {
        syncBannerLeftBadgeVisibility(this, selectors);
        syncGalleryVideos(this);
      },
      slideChangeTransitionEnd: function() {
        syncBannerLeftBadgeVisibility(this, selectors);
      },
    },
  });
  var reviewSwiper = new Swiper(selectors.section + ' .review_swiper', {
    spaceBetween: 10,
    slidesPerView: 1,
    pagination: {
      el: '.review_swiper_pagination',
      clickable: true,
    },
  });
  var reviewSwiperMobile_1 = new Swiper(selectors.section + ' .review_swiper_mobile', {
    spaceBetween: 10,
    slidesPerView: 1,
    pagination: {
      el: selectors.section + ' .review_swiper_pagination_mobile',
      clickable: true,
    },
  });
};

// "Love By Thousands" carousel (Swiper + play/pause) lives in assets/love-by-thousands.js.

// "Watch out for cheap replicas" popup moved to assets/replica-warning-modal.js, loaded
// site-wide from layout/theme.liquid - the FAQ section (many templates, not just this one)
// can also trigger it via a plain `href="#open-replica-warning-modal"` link in rich-text
// content, so it can no longer live in a script that's only loaded on bundle-builder sections.
